import { useAuthUser } from '@frontegg/react';
import Box from '@mui/material/Box';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import RolesType from '../../utils/enum/RolesType';
import getRoles from '../../utils/getRoles';
import SurveysList from '../Surveys/SurveysList/surveysList';
import Tenants from '../Tenants/tenants';
import Title from '../Title/title';
import ColorSwatches from './colorSwatches/colorSwatches';
import LinkTab from './linkTab';
import MailingList from './MailingList/mailingList';
import { TabsSettingsStyled, SettingsStyled } from './styled';
import TabPanel from './TabPanel/tabPanel';

const Settings: FC = () => {
    const { hash } = useLocation();
    const [currentContent, setCurrentContent] = useState(hash || '#mailing-list');
    const { t } = useTranslation('settings');
    const user = useAuthUser();
    const isAdminMoai = getRoles(user).includes(RolesType.ADMIN_MOAI);

    const handleChange = (event: React.SyntheticEvent, newValue: string): void => {
        setCurrentContent(newValue);
    };

    return (
        <SettingsStyled>
            <Title content={t('title')} />
            <Box sx={{ marginTop: '24px' }}>
                <TabsSettingsStyled onChange={handleChange} value={currentContent}>
                    <LinkTab currentContent={currentContent} label={t('tabs.mailingList')} setCurrentContent={setCurrentContent} value="#mailing-list" disableRipple wrapped />
                    <LinkTab currentContent={currentContent} label={t('tabs.colorSwatches')} setCurrentContent={setCurrentContent} value="#color-swatches" disableRipple wrapped />
                    {isAdminMoai && <LinkTab currentContent={currentContent} label={t('tabs.tenants')} setCurrentContent={setCurrentContent} value="#tenants" disableRipple wrapped />}
                    {isAdminMoai && <LinkTab currentContent={currentContent} label={t('tabs.surveys')} setCurrentContent={setCurrentContent} value="#surveys" disableRipple wrapped />}
                </TabsSettingsStyled>
                <TabPanel index='#mailing-list' value={currentContent}>
                    <MailingList />
                </TabPanel>
                <TabPanel index='#color-swatches' value={currentContent}>
                    <ColorSwatches />
                </TabPanel>
                {isAdminMoai && (
                    <TabPanel index='#tenants' value={currentContent}>
                        <Tenants />
                    </TabPanel>
                )}
                {isAdminMoai && (
                    <TabPanel index='#surveys' value={currentContent}>
                        <SurveysList />
                    </TabPanel>
                )}
            </Box>
        </SettingsStyled>
    );
};

export default Settings;
